import request from '@/utils/request'

let RegionagentApi = {

    /*代理列表*/
    regionagentList(data) {
        return request._post('/shop/plus.regionagent.regionagent/index', data);
    },
    /*代理添加*/
    regionagentAdd(data) {
        return request._post('/shop/plus.regionagent.regionagent/add', data);
    },
    /*代理修改*/
    regionagentEdit(data) {
        return request._post('/shop/plus.regionagent.regionagent/edit', data);
    },
    /*代理删除*/
    regionagentDel(data) {
        return request._post('/shop/plus.regionagent.regionagent/delete', data);
    },

    /*获取区域树*/
    getTree(data, errorback) {
      return request._post('/shop/plus.regionagent.regiontree/index', data);
    }, 

    /*获取设置*/
    getSetting(data) {
        return request._get('/shop/plus.regionagent.setting/index', data);
    },
    /*保存设置*/
    saveSetting(data) {
        return request._post('/shop/plus.regionagent.setting/index', data);
    },

     /*开启代理*/
     open(data) {
        return request._post('/shop/plus.regionagent.regiontree/open', data);
    },
    // 设置代理
    setting(data) {
        return request._post('/shop/plus.regionagent.regiontree/setting', data);
    },
    // 获取设置
    getSettings(data){
        return request._post('/shop/plus.regionagent.regiontree/getSettings', data);
    },
    //同步数据——企业数量/人口总数
    sync_district(data){
        return request._post('/shop/plus.regionagent.regiontree/sync_district', data);
    },

}

export default RegionagentApi;



// WEBPACK FOOTER //
// ./src/api/regionagent.js